<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 57">
  <path
    data-player="true"
    fill="#808080"
    d="M28.5 0C25.8 18.8 16.5 28.6 0 28.5c14.1 2 28.4 3.6 28.5 28.5-.3-20.5 10.9-28.1 28.5-28.5-16.9-.7-28.9-7.3-28.5-28.5Z"
  />
</svg>
